import { Component, Input, OnInit } from '@angular/core';
import { ORGANIZATION_TYPES, RECORD_STATUS_VALUES, TABLE_OPTION_VALUES } from '../../constants/api-constants';
import { GlobalService } from '../../services/global/global.service';
import { AnimateTimings } from '@angular/animations';

@Component({
  selector: 'app-quotes-table-options',
  templateUrl: './quotes-table-options.component.html',
  styleUrls: ['./quotes-table-options.component.scss'],
})
export class QuotesTableOptionsComponent implements OnInit {

  @Input() optionsData: any;
  @Input() onPathSelected!: (data: any) => void;

  RECORD_STATUS_VALUES = RECORD_STATUS_VALUES;
  TABLE_STATUS_VALUES = TABLE_OPTION_VALUES

  id: any;
  row: any;
  quoteStatus: any;
  role : any;
  hideEditButton: any;
  hideFinalizeButton: any;
  hideConvertButton: any;
  hideDeleteButton: any;

  showCloneBtn:any;

  constructor(private _globalService: GlobalService) {
  }

  ngOnInit() {
    this.showCloneBtn = localStorage.getItem("CType") !== ORGANIZATION_TYPES.DMC
    this.updateActionsForRoles();
    if (this.row) {
      this.quoteStatus = this.row.status;
    }
  }

  updateActionsForRoles(){

    this.role = localStorage.getItem("Role");
    this._globalService.roles$.subscribe((roles) => {
      const leadModule = roles?.modules.find((module: any) => module.name === "Leads");
      const permissions = leadModule.permissions;
      if (permissions.editQuote) {
        this.hideEditButton = true;
      }
      else {
        this.hideEditButton = false;
      }

      if (permissions.finalizeQuote) {
        this.hideFinalizeButton = true;
      }
      else {
        this.hideFinalizeButton = false;
      }

      if (permissions.convertQuote) {
        this.hideConvertButton = true;
      }
      else {
        this.hideConvertButton = false;
      }

      if(this.role === "ClientAccountant")
      {
        this.hideDeleteButton = false;
      }
      else
      {
        this.hideDeleteButton= true;
      }


    })
  }

  // Navigate to path
  routeToPath(path: any) {
    this.onPathSelected({ path: path });
  }

}
